import React, { useEffect, useState, useCallback } from "react";
import axiosInstance from "../api/axiosInstance";

const AddEditUserMaster = ({
  editData,
  groupId,
  restId,
  onClose,
  onSuccess,
}) => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");

  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= TITLE CASE ================= */
  const toTitleCase = (text = "") =>
    text
      .toLowerCase()
      .split(" ")
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");

  /* ================= LOAD EDIT ================= */
  useEffect(() => {
    if (editData) {
      setUserName(editData.user_Name || "");
    } else {
      setUserName("");
    }
  }, [editData]);

  /* ================= SUBMIT ================= */
  const handleSubmit = useCallback(async () => {
    if (loading) return;

    const formattedName = toTitleCase(userName);

    if (!formattedName.trim()) {
      alert("Enter user name");
      return;
    }

    if (groupId === undefined || restId === undefined) {
      alert("Group or Restaurant missing");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        user_Id: editData?.user_Id || 0,
        groupId: Number(groupId),
        restId: Number(restId),
        user_Name: formattedName,
        status: true,
        createdBy: storedUser?.userId || 0,
        modifiedBy: storedUser?.userId || 0,
      };

      // ✅ ADD
      if (!editData) {
        await axiosInstance.post("/UserMaster", payload);
      }
      // ✅ UPDATE
      else {
        await axiosInstance.put(
          `/UserMaster/${editData.user_Id}`,
          payload
        );
      }

      onSuccess?.();
      onClose?.();
    } catch (err) {
      console.error("Save error:", err);
      alert("Error saving user");
    } finally {
      setLoading(false);
    }
  }, [userName, editData, groupId, restId, loading, onClose, onSuccess]);

  /* ================= KEYBOARD ================= */
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }

    if (e.key === "Escape") {
      onClose?.();
    }
  };

  /* ================= CHANGE ================= */
  const handleChange = (e) => {
    let value = e.target.value.replace(/\s{2,}/g, " ");
    setUserName(value);
  };

  const handleBlur = () => {
    setUserName((prev) => toTitleCase(prev));
  };

  /* ================= UI ================= */
  return (
    <div
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl w-[400px] p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold mb-3">
          {editData ? "Edit User" : "Add User"}
        </h3>

        <input
          type="text"
          value={userName}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          placeholder="Enter user name"
          autoFocus
          className="w-full border px-3 py-2 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500 outline-none"
        />

        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-2 border rounded-lg">
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddEditUserMaster;